import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectTitle } from "../../actions";
import { AiFillCaretUp, AiFillCaretDown } from "react-icons/ai";

interface Network {
  id: string;
  title: string;
  network: string;
  image: string;
}

interface RootState {
  selectedTitle: any;
  networks: Network[];
}

const SecondDropdown = () => {
  const networks = useSelector((state: RootState) => state.networks);
  const selectedTitle = useSelector((state: RootState) => state.selectedTitle);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dispatch = useDispatch();
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const storedTitle = localStorage.getItem("selectedTitle");
    if (storedTitle) {
      dispatch(selectTitle(storedTitle));
    }
  }, [dispatch]);

  const handleTitleChange = (title: string) => {
    localStorage.setItem("selectedTitle", title);
    dispatch(selectTitle(title));
  };

  useEffect(() => {
    const closeDropdown = (e: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("click", closeDropdown);

    return () => {
      document.removeEventListener("click", closeDropdown);
    };
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className="relative inline-block w-full flex-1" ref={dropdownRef}>
      <div
        className="bg-transparent_100 rounded-3xl flex items-center gap-4 w-full p-2 px-3 relative cursor-pointer"
        onClick={toggleDropdown}
      >
        {selectedTitle ? (
          <div className="flex items-center gap-3 text-white">
            <div className="flex justify-center items-center w-10 h-10 border border-transparent_200 rounded-xl">
              <img
                src={
                  networks.find(
                    (network: { title: any }) => network.title === selectedTitle
                  )?.image
                }
                alt={`Logo of ${selectedTitle}`}
                className="h-4"
              />
            </div>
            <div className="flex flex-col">
              <h4 className="text-sm font-medium">{selectedTitle}</h4>
              <span className="text-10 text-opacity-50">
                {
                  networks.find(
                    (network: { title: any }) => network.title === selectedTitle
                  )?.network
                }
              </span>
            </div>
          </div>
        ) : (
          networks.length > 0 && (
            <div className="flex items-center gap-2 text-white">
              <div className="border border-transparent_200 w-10 h-10 flex justify-center items-center rounded-xl">
                <img
                  src={networks[0].image}
                  alt={`Logo of ${networks[0].title}`}
                  className="w-4 h-4"
                />
              </div>
              <div className="flex flex-col">
                <h4 className="text-sm font-medium">{networks[0].title}</h4>
                <span className="text-12 text-opacity-50">
                  {networks[0].network}
                </span>
              </div>
            </div>
          )
        )}
        <div className="ml-2">
          {isDropdownOpen ? (
            <AiFillCaretUp className="absolute right-4 top-7 w-4 text-white" />
          ) : (
            <AiFillCaretDown className="absolute right-4 top-7 w-4 text-white" />
          )}
        </div>
      </div>

      {isDropdownOpen && (
        <ul className="bg-drawer_bg rounded-3xl flex flex-col gap-1 w-full cursor-pointer z-10 absolute top-16 h-48 overflow-y-auto scrollbar-hide">
          {networks.map((network) => (
            <li
              key={network.id}
              onClick={() => {
                handleTitleChange(network.title);
                toggleDropdown();
              }}
              className={`rounded-3xl flex items-center gap-4 w-full p-2 px-3 cursor-pointer hover:bg-transparent_600 transition duration-200 ${
                selectedTitle === network.title ? "transparent_100" : ""
              }`}
            >
              <div className="flex gap-3 items-center">
                <div className="flex justify-center items-center w-10 h-10 border border-transparent_200 rounded-xl">
                  <img
                    src={network.image}
                    alt={`Logo of ${network.title}`}
                    className="h-4"
                  />
                </div>
                <div className="flex flex-col">
                  <h4 className="text-sm font-medium">{network.title}</h4>
                  <span className="text-12 text-opacity-50">
                    {network.network}
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SecondDropdown;
